import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-whats-covered',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './whats-covered.component.html',
  styleUrl: './whats-covered.component.scss',
})
export class WhatsCoveredComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'What Does Travel Insurance Cover? | Insurance Plans | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `World2Cover travel insurance offers basics, essentials or top cover, single or multi-trip, with optional cruise and winter sports cover on selected plans.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content:
        'What Does Travel Insurance Cover? | Insurance Plans | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover travel insurance offers basics, essentials or top cover, single or multi-trip, with optional cruise and winter sports cover on selected plans.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
